import * as swcHelpers from '@swc/helpers';
import { useQuery } from '@grandvisionhq/graphql';
import { useStockIndicator } from '@grandvisionhq/inventory';
import GET_MY_WISHLIST_PRODUCT from '../operations/queries/get-my-wishlist-product.js';
import GET_MY_WISHLIST_VARIANT from '../operations/queries/get-my-wishlist-variant.js';
import { combineRefetchFunctions } from '../utils/combine-refetch-functions.js';
import { combineWishlistData } from '../utils/combine-wishlist-data.js';
import { mapShoppingListToWishlistItems } from '../utils/map-shopping-list-to-wishlist-items.js';

const useGetUserWishlist = ({ locale , isAuthLoading , isUserLoggedIn  })=>{
    var ref, ref1, ref2, ref3, ref4, ref5;
    const { thresholds  } = useStockIndicator();
    const userWishlistQueryOptions = {
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        },
        skip: isAuthLoading || !isUserLoggedIn
    };
    const { data: userWishlistProductData , loading: userWishlistProductLoading , error: userWishlistProductError , refetch: userWishlistProductRefetch ,  } = useQuery(GET_MY_WISHLIST_PRODUCT, swcHelpers.objectSpread({}, userWishlistQueryOptions));
    const { data: userWishlistVariantData , loading: userWishlistVariantLoading , error: userWishlistVariantError , refetch: userWishlistVariantRefetch ,  } = useQuery(GET_MY_WISHLIST_VARIANT, swcHelpers.objectSpread({}, userWishlistQueryOptions));
    const combinedUserData = combineWishlistData(userWishlistVariantData === null || userWishlistVariantData === void 0 ? void 0 : (ref = userWishlistVariantData.me) === null || ref === void 0 ? void 0 : ref.wishlist, userWishlistProductData === null || userWishlistProductData === void 0 ? void 0 : (ref1 = userWishlistProductData.me) === null || ref1 === void 0 ? void 0 : ref1.wishlist);
    var ref6;
    const wishlistId = (ref6 = (userWishlistProductData === null || userWishlistProductData === void 0 ? void 0 : (ref2 = userWishlistProductData.me) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.wishlist) === null || ref3 === void 0 ? void 0 : ref3.id) || (userWishlistVariantData === null || userWishlistVariantData === void 0 ? void 0 : (ref4 = userWishlistVariantData.me) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.wishlist) === null || ref5 === void 0 ? void 0 : ref5.id)) !== null && ref6 !== void 0 ? ref6 : '';
    const mappedUserData = {
        items: mapShoppingListToWishlistItems(locale, combinedUserData, thresholds),
        id: wishlistId
    };
    const combinedUserRefetch = combineRefetchFunctions(userWishlistProductRefetch, userWishlistVariantRefetch);
    var ref7;
    const error = (ref7 = userWishlistProductError || userWishlistVariantError) !== null && ref7 !== void 0 ? ref7 : null;
    return {
        data: !error ? mappedUserData : null,
        loading: userWishlistProductLoading || userWishlistVariantLoading,
        error,
        refetch: combinedUserRefetch
    };
};

export { useGetUserWishlist };
//# sourceMappingURL=use-get-user-wishlist.js.map
